module.exports = __webpack_public_path__ + "img/usa.8229e1c2.svg";